// Where the Help entry sends users inside the native shell, in place of the
// in-app Crisp widget. Each brand's Crisp Helpdesk runs on the SAME Crisp
// website as the chat (FI 99ebc3f4 = crisp_id_fi, SE d3fecb10 = crisp_id_sv,
// UK b26697a1 = crisp_id_uk), so the support channel and the in-house team
// answering it are unchanged; only the process hosting the widget moves.
//
// MUST open in the system browser, not an in-app tab: Play's Data safety scope
// covers "a webview which has been opened from your app, if your app is in
// control of the code/behavior delivered through that webview". These hosts are
// absent from kuori's allowNavigation, so the shell pushes them out.
//
// fi-SE falls back to Swedish — the SE helpdesk publishes /sv/ and /en/ only.
// Keep in sync with st-toosa's copy of this constant.
export const SUPPORT_HELPDESK_LINK = {
  'fi-FI': 'https://helpdesk.someturva.fi/fi/',
  'sv-FI': 'https://helpdesk.someturva.fi/sv/',
  'en-FI': 'https://helpdesk.someturva.fi/en/',
  'sv-SE': 'https://helpdesk.somebuddy.se/sv/',
  'fi-SE': 'https://helpdesk.somebuddy.se/sv/',
  'en-SE': 'https://helpdesk.somebuddy.se/en/',
  'en-GB': 'https://helpdesk.somebuddy.com/en/',
  default: 'https://helpdesk.someturva.fi/fi/',
};

// Where the /voucher page's account-deletion link sends users. Deletion itself
// is not self-service (DEV-709): support deletes the account by hand once they
// get the request, per the helpdesk article, which Apple guideline 5.1.1(v)
// explicitly permits as an alternative to an in-app delete flow. This is the
// only exit from /voucher for a pupil whose subscription lapsed — see the
// `inactive` redirect in `_app.tsx` — so it must never 404.
//
// Every locale below points at its OWN article, in its own language and on its
// own brand's helpdesk. These were read from the Crisp API rather than by
// browsing the helpdesk sites, which do not list every published article and
// had previously suggested four of these did not exist.
//
// fi-SE is the one real fallback: the SomeBuddy SE helpdesk has no /fi/ locale
// at all, only /sv/ and /en/. It is also on its way out — Finnish is being
// removed from the Swedish app — so the Swedish article covers it until then.
export const ACCOUNT_DELETION_ARTICLE = {
  'fi-FI':
    'https://helpdesk.someturva.fi/fi/article/miten-voin-poistaa-kayttajatilini-someturvasta-1ar7drf/',
  'sv-FI':
    'https://helpdesk.someturva.fi/sv/article/hur-kan-jag-radera-mitt-anvandarkonto-pa-someturva-4jcyc3/',
  'en-FI':
    'https://helpdesk.someturva.fi/en/article/how-can-i-delete-my-user-account-on-someturva-dv6jis/',
  'sv-SE':
    'https://helpdesk.somebuddy.se/sv/article/hur-kan-jag-radera-mitt-anvandarkonto-pa-somebuddy-lgeqev/',
  // No /fi/ locale on the SE helpdesk; Swedish is the closest, and Finnish is
  // being dropped from the Swedish app anyway.
  'fi-SE':
    'https://helpdesk.somebuddy.se/sv/article/hur-kan-jag-radera-mitt-anvandarkonto-pa-somebuddy-lgeqev/',
  'en-SE':
    'https://helpdesk.somebuddy.se/en/article/how-can-i-delete-my-user-account-on-somebuddy-1847d6d/',
  'en-GB':
    'https://helpdesk.somebuddy.com/en/article/how-can-i-delete-my-somebuddy-account-pg4gao/',
  default:
    'https://helpdesk.someturva.fi/fi/article/miten-voin-poistaa-kayttajatilini-someturvasta-1ar7drf/',
};

export const GDPR_CONSENT_GIVEN = 'gdprConsentGiven';
export const GDPR_STATISTICS_ENABLED = 'gdprStatisticsEnabled';
export const GDPR_MARKETING_ENABLED = 'gdprMarketingEnabled';
export const GDPR_FUNCTIONAL_ENABLED = 'gdprFunctionalEnabled';
export const PREFERRED_LOGIN_VARIANT = 'preferLoginVariant';

export const PRODUCT_TYPES = {
  STUDENT: 'STUDENT',
  PERSONAL: 'PERSONAL',
  PROFESSIONAL: 'PROFESSIONAL',
  MANAGER: 'MANAGER',
};

export const ADULT_PRODUCT_TYPES = [
  PRODUCT_TYPES.PERSONAL,
  PRODUCT_TYPES.MANAGER,
];

// Long-lived-session cookie names. Defined here (not in utils/refresh-cookie)
// because pages import them into the CLIENT bundle, and refresh-cookie pulls
// in Node's crypto module which must stay server-only.
export const REFRESH_COOKIE_NAME = 'refresh';
export const KEEP_SIGNED_IN_COOKIE_NAME = 'keep_signed_in';
